import './home.css'
import React from 'react'
import aboutUs from '../../assets/aboutUs.jpeg'

export default function Description(){
    return(
        <div>
             {/* <!-- Start Work Steps --> */}
            <div class="work-steps" id="about">
            <h2 class="main-title">About</h2>
            <div class="container">
                <img src={aboutUs} style={{width:'450px'}} alt="" class="image" />
                <div class="info">
                <div class="box">
                    <img src="imgs/work-steps-1.png" alt="" />
                    <div class="text">
                    <h3>Astronomy</h3>
                    <p>
                        <i>“We are all made of stardust”.</i> <br />
                        Astronomy is the study of the entire universe and is the key to understanding who we are in the infinite.
                    </p>
                    </div>
                </div>
                <div class="box">
                    <img src="" alt="" />
                    <div class="text">
                    <h3>Mathematics</h3>
                    <p>
                        It is the building block of all that we see - the poetry of logical ideas, the language of the universe. 
                    </p>
                    </div>
                </div>
                <div class="box">
                    <img src="imgs/work-steps-3.png" alt="" />
                    <div class="text">
                    <h3>Engineering</h3>
                    <p>
                        It is the application of science and mathematics to solve problems and make the world a better place.
                    </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
            {/* <!-- End Work Steps --> */}
        </div>
    )
}